import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "promo-code flex-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('deletePromo', _ctx.promo)))
    }, _cache[1] || (_cache[1] = [
      _createElementVNode("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: "12",
        width: "12",
        viewBox: "0 0 20 20"
      }, [
        _createElementVNode("path", { d: "m6.062 15.167-1.229-1.229L8.771 10 4.833 6.062l1.229-1.229L10 8.771l3.938-3.938 1.229 1.229L11.229 10l3.938 3.938-1.229 1.229L10 11.229Z" })
      ], -1)
    ])),
    _createElementVNode("span", null, _toDisplayString(_ctx.promo.PromoCode), 1)
  ]))
}